import { Checkbox, TableContainer } from "@material-ui/core";
import React, { memo, useCallback, useEffect, useState } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import Paper from "@mui/material/Paper";
import { ReactComponent as PayNowSvg } from "assets/icons/Property.svg";
import { ReactComponent as SortAbleSvg } from "assets/icons/sort-able-svg.svg";
import MyButton from "components/MyButton";
import SearchComp from "components/Searchcomponent";
import RightDrawer from "components/drawer";
import Loader from "components/loader/Loader";
import { debounce } from "lodash";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import FinanceService from "../../../Lib/API/Finance";
import FinanceDrawer from "../Drawer";
import ExpandableRow from "../TransationTableComponents/ExpandableRow";
import BatchBillingTableData from "./BatchBillingTableData";
import "./style.scss";
const initialFilters = {
  search: undefined,
};
const BatchBillingTable = ({
  filters,
  sortCharged,
  sort,
  setsearchoptions,
  page,
  setCount,
  productData,
  setPage,
  count,
  setProductData,
  handleClick,
  setBatchId,
  setOpenBatch,
  setEditData,
  searchValue,
  batch_id,
  modalOpen,
  batchList,
  setBatchList,
}) => {
  const selectedBatch_Id = useSelector((state) => state.homeReducer.selectedBatch_Id);
  const getValueBatchModal = useSelector((state) => state.homeReducer.getValueForModal);

  const initialValues = {
    filter:
      batch_id !== null
        ? {
          batch_billing: selectedBatch_Id?.type === "batch" ? selectedBatch_Id?.data : batch_id,
        }
        : {},
    sort: {},
  };

  const [chargeSorting, setChargeSorting] = useState(initialValues);

  const [openModal, setOpenModal] = React.useState(false);
  const [selectionModel /* setSelectionModel */] = React.useState([]);
  const [drawerData, setDrawerData] = useState({});
  const [currentAccount, setCurrentAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [check, setCheck] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [filter, setFilters] = useState(initialFilters);
  const [financeData, setFinanceData] = useState("");
  // const [batchID, setBatchId] = useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [finance, setFinance] = useState(false);
  const [batchDataCount, setBatchDataCount] = useState()

  const transactionAPi = async () => {
    setFinanceData(null);
    const token = await getAccessTokenSilently();
    if (batch_id && batch_id != null || selectedBatch_Id) {
      setFinance(true);
      FinanceService.ViewBatchPayment(token, financeTablePage !== 0 ? financeTablePage + 1 : 1, 30, {
        filter:
          chargeSorting?.filter.batch_billing != null
            ? chargeSorting?.filter
            : batch_id !== null && {
              batch_billing: selectedBatch_Id?.type === "batch" ? selectedBatch_Id?.data : batch_id,
            },
        sort: chargeSorting?.sort,
      })
        .then((res) => {
          setFinance(false);
          const result = res?.payload?.data;
          setFinanceData(result);
          setBatchDataCount(res?.payload?.pagination?.count)
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
      return;
    }
  };

  const chargedsorting = (e) => {
    setChargeSorting((prev) => ({
      ...prev,
      sort: {
        [e]: prev.sort[e] === 1 ? -1 : 1,
      },
      filter:
        batch_id !== null
          ? {
            batch_billing: selectedBatch_Id?.type === "batch" ? selectedBatch_Id?.data : batch_id,
          }
          : {},
    }));
  };

  useEffect(() => {
    setPage(0);
  }, []);
  useEffect(() => {
    setBatchId(batch_id);
  }, [batch_id]);
  const fetchMyAPI = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    await FinanceService.getListofBatchBilling(token, page + 1, 30, {
      sort: filters?.sort,
      search: filter?.search,
    })
      .then((res) => {
        const result = res?.payload?.data;
        setProductData(result);
        setCount(res?.payload?.pagination?.count);
        setLoading(false);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  // useEffect(() => {
  //   setBatchId(batch_id);
  // });
  const debounceSearch = useCallback(
    debounce(() => {
      if (filter?.search) {
        fetchMyAPI();
      }
    }, 1000),
    [filter.search, filter, page]
  );
  useEffect(() => {
    if (filter?.search) {
      debounceSearch();
    } else {
      fetchMyAPI();
    }
    return () => debounceSearch.cancel();
  }, [filter.search, filters, page, batchList]);

  const [financeTablePage, setFinanceTablePage] = useState(0);

  useEffect(() => {
    transactionAPi();
  }, [batchList]);

  useEffect(() => {
    transactionAPi();
  }, [batch_id, financeTablePage]);

  useEffect(() => {
    window.addEventListener("save-transaction", fetchMyAPI);
    window.addEventListener("refresh", fetchMyAPI);
    return () => {
      window.removeEventListener("save-transaction", fetchMyAPI);
      window.removeEventListener("refresh", fetchMyAPI);
    };
  }, [filters, page, getAccessTokenSilently]);

  const onEditNowClick = (row) => {
    setEditData(row);

    if (row?.hasOwnProperty("_id")) {
      setOpenBatch(true);
    }
  };
  const onSearchChange = (e) => {
    const name = e.target.value;
    setPage(0);
    setFilters((prev) => ({
      ...prev,
      search: name ? name : undefined,
    }));
  };
  /**
   * @param {React.ChangeEvent<HTMLInputElement>} e
   * @param {string} accountId
   */

  return (
    <div className="w-100">
      <div className="filteration">
        <div className="activated-ledger mb-5" style={{ width: "400px" }}>
          <div className="sub-header-functions batch-filter-serach-bar">
            <SearchComp
              value={filter?.search}
              setSearchText={onSearchChange}
              placeholder="Search by batch billing name"
            />
          </div>
        </div>
      </div>
      <div className="family-table-container p-7 pb-15">
        <div className="home-table-container mt-0 no-box-shadow">
          <div className="d-flex justify-content-between mb-7 h-40px">
            <div className="yah-sub">Scripts</div>
          </div>
          <TableContainer component={Paper} className="scroll-table">
            <Table aria-label="collapsible table">
              <TableHead className="main-table__header sticky-table-header">
                <TableRow>
                  <TableCell
                    className="billing-name"
                    align="left"
                  // onClick={() => sortCharged("title")}
                  >
                    NAME
                  </TableCell>
                  <TableCell
                    className="billing-amount"
                    align="left"
                  // onClick={() => sortCharged("amount")}
                  >
                    AMOUNT
                  </TableCell>
                  <TableCell
                    className="billing-status"
                    align="left"
                  // onClick={() => sortCharged("status")}
                  >
                    STATUS
                  </TableCell>
                  <TableCell
                    className="billing-type"
                    align="left"
                  // onClick={() => sortCharged("type")}
                  >
                    TYPE
                  </TableCell>
                  <TableCell
                    className="billing-created-date"
                    align="left"
                  // onClick={() => sortCharged("Created_by")}
                  >
                    CREATED BY
                  </TableCell>
                  <TableCell
                    className="billing-type"
                    align="left"
                  // onClick={() => sortCharged("type")}
                  >
                    #
                  </TableCell>
                  <TableCell className="sticky-header-column" />
                </TableRow>

              </TableHead>

              <TableBody>
                {productData?.length === 0 ? (
                  loading == true ? (
                    <div className="batch-loader ">
                      <Loader />
                    </div>
                  ) : (
                    <td colSpan={12}>
                      <div className="record-text">No record found</div>
                    </td>
                  )
                ) : loading == true ? (
                  <div className="batch-loader ">
                    <Loader />
                  </div>
                ) : (
                  productData?.map((row) => (
                    <BatchBillingTableData
                      key={row.name}
                      row={row}
                      check={check}
                      financeTablePage={financeTablePage}
                      setFinanceTablePage={setFinanceTablePage}
                      // onPayNowClick={onPayNowClick}
                      // onReversalClick={onReversalClick}
                      setDrawerData={setDrawerData}
                      setOpenModal={setOpenModal}
                      setPage={setPage}
                      page={page}
                      setBatchId={setBatchId}
                      handleClick={handleClick}
                      onEditNowClick={onEditNowClick}
                      financeData={financeData}
                      batchDataCount={batchDataCount}
                      setBatchDataCount={setBatchDataCount}
                      finance={finance}
                      batchId={batch_id}
                      modalOpen={modalOpen}
                      chargedSorting={chargedsorting}
                      chargeSorting={chargeSorting}
                      batchList={batchList}
                      setBatchList={setBatchList}
                    />
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {productData?.length === 0 ? (
            ""
          ) : (
            <div className="pagination-custom mt-2">
              <Pagination
                count={Math.ceil(count / 30)}
                color="primary"
                variant="outlined"
                page={page + 1}
                onChange={(event, value) => {
                  setPage(value - 1);
                }}
              />
            </div>
          )}
        </div>
        <RightDrawer
          open={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
        >
          <FinanceDrawer
            data={drawerData}
            handleClose={() => setOpenModal(false)}
          // onReversalClick={onReversalClick}
          />
        </RightDrawer>
      </div>
    </div>
  );
};

export default memo(BatchBillingTable);
